<template>
  <div>
    <div class="row">
      <div class="col-sm-12">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-center">
              <router-link :to="{name: 'manualPersons'}">powrót</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="card">
          <div class="card-header">
            <i class="fa fa-address-book-o"></i>
            Dane w obiekcie: {{ osoba ? osoba.branchName : '' }}
            <div class="card-header-actions">
              <a class="card-header-action" href @click.prevent="splitPerson()">
                Zapisz jako nowy klient
              </a>
            </div>
          </div>
          <client-details-card v-bind:client="osoba"></client-details-card>
        </div>
      </div>
      <div class="col-md-6">
        <div class="card">
          <div class="card-header">
            <i class="fa fa-address-book-o"></i>
            Dane w systemie CRM
          </div>
          <client-details-card v-bind:client="client"></client-details-card>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-6">
        <div class="card" v-if="suggestedClient">
          <div class="card-header">
            <div>Dane klienta</div>
          </div>
          <div class="card-body">
            <form @submit.prevent="approve()">
              <div class="row form-group" v-bind:class="{ 'highlighted': isHighLighted('firstName')}">
                <div class="col-md-5">Imiona</div>
                <div class="col-md-7">
                  <input type="text" class="form-control" v-model="suggestedClient.firstName"/>
                </div>
              </div>

              <div class="row form-group" v-bind:class="{ 'highlighted': isHighLighted('lastName')}">
                <div class="col-md-5">Nazwisko</div>
                <div class="col-md-7">
                  <input type="text" class="form-control" v-model="suggestedClient.lastName"/>
                </div>
              </div>

              <div class="row form-group" v-bind:class="{ 'highlighted': isHighLighted('pesel')}">
                <div class="col-md-5">PESEL</div>
                <div class="col-md-7">
                  <input type="text" class="form-control" v-model="suggestedClient.pesel"/>
                </div>
              </div>

              <div class="row form-group" v-bind:class="{ 'highlighted': isHighLighted('street')}">
                <div class="col-md-5">Ulica</div>
                <div class="col-md-7">
                  <input type="text" class="form-control" v-model="suggestedClient.street"/>
                </div>
              </div>

              <div class="row form-group" v-bind:class="{ 'highlighted': isHighLighted('streetNo')}">
                <div class="col-md-5">Nr domu</div>
                <div class="col-md-7">
                  <input type="text" class="form-control" v-model="suggestedClient.streetNo"/>
                </div>
              </div>

              <div class="row form-group" v-bind:class="{ 'highlighted': isHighLighted('flatNo')}">
                <div class="col-md-5">Nr mieszkania</div>
                <div class="col-md-7">
                  <input type="text" class="form-control" v-model="suggestedClient.flatNo"/>
                </div>
              </div>

              <div class="row form-group" v-bind:class="{ 'highlighted': isHighLighted('postalCode')}">
                <div class="col-md-5">Kod pocztowy</div>
                <div class="col-md-7">
                  <input type="text" class="form-control" v-model="suggestedClient.postalCode"/>
                </div>
              </div>

              <div class="row form-group" v-bind:class="{ 'highlighted': isHighLighted('city')}">
                <div class="col-md-5">Miasto</div>
                <div class="col-md-7">
                  <input type="text" class="form-control" v-model="suggestedClient.city"/>
                </div>
              </div>

              <div class="row form-group" v-bind:class="{ 'highlighted': isHighLighted('country')}">
                <div class="col-md-5">Kraj</div>
                <div class="col-md-7">
                  <input type="text" class="form-control" v-model="suggestedClient.country"/>
                </div>
              </div>

              <div class="row form-group" v-bind:class="{ 'highlighted': isHighLighted('phone1')}">
                <div class="col-md-5">Telefon</div>
                <div class="col-md-7">
                  <input type="text" class="form-control" v-model="suggestedClient.phone1"/>
                </div>
              </div>
              <div class="row form-group" v-bind:class="{ 'highlighted': isHighLighted('phone2')}">
                <div class="col-md-5">Telefon2</div>
                <div class="col-md-7">
                  <input type="text" class="form-control" v-model="suggestedClient.phone2"/>
                </div>
              </div>

              <div class="row form-group" v-bind:class="{ 'highlighted': isHighLighted('cellPhone')}">
                <div class="col-md-5">Tel. komórkowy</div>
                <div class="col-md-7">
                  <input type="text" class="form-control" v-model="suggestedClient.cellPhone"/>
                </div>
              </div>
              <div class="row form-group" v-bind:class="{ 'highlighted': isHighLighted('email1')}">
                <div class="col-md-5">E-mail</div>
                <div class="col-md-7">
                  <input type="text" class="form-control" v-model="suggestedClient.email1"/>
                </div>
              </div>
              <div class="row form-group" v-bind:class="{ 'highlighted': isHighLighted('email2')}">
                <div class="col-md-5">E-mail2</div>
                <div class="col-md-7">
                  <input type="text" class="form-control" v-model="suggestedClient.email2"/>
                </div>
              </div>
              <div class="row form-group" v-bind:class="{ 'highlighted': isHighLighted('personalId')}">
                <div class="col-md-5">Dowód nr</div>
                <div class="col-md-7">
                  <input type="text" class="form-control" v-model="suggestedClient.personalId"/>
                </div>
              </div>
              <div class="row form-group" v-bind:class="{ 'highlighted': isHighLighted('comments')}">
                <div class="col-md-5">comments</div>
                <div class="col-md-7">
                  <input type="text" class="form-control" v-model="suggestedClient.comments"/>
                </div>
              </div>
              <div class="row form-group" v-bind:class="{ 'highlighted': isHighLighted('zgodaNpdo')}">
                <div class="col-md-5">Zgoda na przetwarzanie danych</div>
                <div class="col-md-7">
                  <select class="form-control" v-model="suggestedClient.zgodaNpdo">
                    <option value="1">TAK</option>
                    <option value="0">NIE</option>
                  </select>
                </div>
              </div>
              <div class="row form-group" v-bind:class="{ 'highlighted': isHighLighted('zgodaNprd')}">
                <div class="col-md-5">Zgoda na wyświetlanie danych i rachunków</div>
                <div class="col-md-7">
                  <select class="form-control" v-model="suggestedClient.zgodaNprd">
                    <option value="1">TAK</option>
                    <option value="0">NIE</option>
                  </select>
                </div>
              </div>
              <div class="row form-group" v-bind:class="{ 'highlighted': isHighLighted('zgodaNoih')}">
                <div class="col-md-5">Zgoda marketingowa</div>
                <div class="col-md-7">
                  <select class="form-control" v-model="suggestedClient.zgodaNoih">
                    <option value="1">TAK</option>
                    <option value="0">NIE</option>
                  </select>
                </div>
              </div>
              <div class="row form-group" v-bind:class="{ 'highlighted': isHighLighted('zgodaEmail')}">
                <div class="col-md-5">Zgoda E-mail</div>
                <div class="col-md-7">
                  <select class="form-control" v-model="suggestedClient.zgodaEmail">
                    <option value="1">TAK</option>
                    <option value="0">NIE</option>
                  </select>
                </div>
              </div>

              <div class="row form-group" v-bind:class="{ 'highlighted': isHighLighted('kartamagn')}">
                <div class="col-md-5">kartamagn</div>
                <div class="col-md-7">
                  <input type="text" class="form-control" v-model="suggestedClient.kartamagn"/>
                </div>
              </div>
              <button type="submit" class="btn btn-primary">Zatwierdź</button>
            </form>
          </div>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
  import osobaService from '@Service/osobaService';
  import ClientDetailsCard from '@Component/client-details-card';
  import { router } from '@Router';
  import { toastSuccess, toastError } from '../helpers';

  export default {
    components: { ClientDetailsCard },
    data() {
      return {
        osoba: null,
        client: null,
        suggestedClient: null,
      };
    },
    computed: {},
    methods: {
      getData: function () {
        osobaService
          .getManualSyncDetails({
            osobaId: this.$route.params.osobaId,
            branchId: this.$route.params.branchId,
          })
          .then(response => {
            this.osoba = (response.data || {}).osoba;
            this.client = (response.data || {}).client;
            const hasAddress = data => ![
              data.city, // todo do sprawdzenia czy nie ma tego zawsze
              data.street,
              data.postalCode,
            ].some(el => !el);
            const isOutdated = this.osoba.modificationDate < this.client.modificationDate;
            const newData = isOutdated ? this.client : this.osoba;
            const oldData = isOutdated ? this.osoba : this.client;
            this.suggestedClient = {
              clientId: this.client.clientId,
              firstName: newData.firstName,
              lastName: newData.lastName,
              pesel: newData.pesel || oldData.pesel,
              street: hasAddress(newData) ? newData.street : oldData.street,
              streetNo: hasAddress(newData) ? newData.streetNo : oldData.streetNo,
              flatNo: hasAddress(newData) ? newData.flatNo : oldData.flatNo,
              postalCode: hasAddress(newData) ? newData.postalCode : oldData.postalCode,
              city: hasAddress(newData) ? newData.city : oldData.city,
              country: hasAddress(newData) ? newData.country : oldData.country,
              phone1: newData.phone1 || oldData.phone1,
              phone2: newData.phone2 || oldData.phone2,
              cellPhone: newData.cellPhone || oldData.cellPhone,
              email1: newData.email1 || oldData.email1,
              email2: newData.email2 || oldData.email2,
              personalId: newData.personalId || oldData.personalId,
              comments: newData.comments || oldData.comments,
              zgodaNpdo: newData.zgodaNpdo,
              zgodaNprd: newData.zgodaNprd,
              zgodaNoih: newData.zgodaNoih,
              zgodaEmail: newData.zgodaEmail,
              kartamagn: newData.kartamagn || oldData.kartamagn,
              modification_date: newData.modification_date,
            };
          })
          .catch(() => router.push({ name: 'manualPersons' }));
      },
      isHighLighted: function (name) {
        return this.client[name] !== this.osoba[name];
      },
      approve: function () {
        osobaService
          .approveManualSync({
            osobaId: this.$route.params.osobaId,
            branchId: this.$route.params.branchId,
            data: this.suggestedClient,
          })
          .then(() => {
            router.push({ name: 'manualPersons' });
            toastSuccess(this.$t('messages.manual-person-approve.success'));
          })
          .catch(toastError);
      },
      splitPerson: function () {
        osobaService
          .splitPersonClient({
            osobaId: this.$route.params.osobaId,
            branchId: this.$route.params.branchId,
          })
          .then(() => {
            router.push({ name: 'manualPersons' });
            toastSuccess(this.$t('messages.manual-person-split.success'));
          })
          .catch(toastError);
      },
    },
    mounted: function () {
      this.getData();
    },
  };
</script>

<style scoped>
  .highlighted .form-control {
    border-color: orange;
    font-weight: bold;
  }
</style>
